import { guides } from '@/mocks/guides';
import GuideCard from '@/components/feature/GuideCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function LatestSection() {
  const latest = [...guides]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 5);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/60 border-y border-background-200">
      <SectionHeading
        eyebrow="近期更新"
        title="最新补充的避雷清单"
        description="平台规则一直在变，这些是最近复核或新增的清单。"
        linkTo="/guides"
        linkLabel="按时间查看全部"
      />

      <div className="flex flex-col">
        {latest.map((guide) => (
          <GuideCard key={guide.slug} guide={guide} layout="row" />
        ))}
      </div>
    </section>
  );
}